module.exports = __webpack_public_path__ + "static/media/bitmap.21ba5c43.png";